import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IModelSlice {
  isPermissionDeniedModelOpen: boolean;
}
const initialState: IModelSlice = {
  isPermissionDeniedModelOpen: false,
};

const modelSlice = createSlice({
  name: 'model',
  initialState,
  reducers: {
    setIsPermissionDeniedModelOpen(state: IModelSlice, action: PayloadAction<boolean>) {
      state.isPermissionDeniedModelOpen = action.payload;
    },
  },
});

export const { actions: modelAction, reducer: modelReducer } = modelSlice;
